import React from 'react';
import styles from './Section.module.scss';

interface SectionProps {
    title?: string;
    subtitle?: string;
    children: React.ReactNode;
    className?: string;
    background?: 'white' | 'gray' | 'primary' | 'gradient';
    padding?: 'sm' | 'md' | 'lg' | 'xl';
    textAlign?: 'left' | 'center' | 'right';
    maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

const Section: React.FC<SectionProps> = ({
    title,
    subtitle,
    children,
    className = '',
    background = 'white',
    padding = 'lg',
    textAlign = 'center',
    maxWidth = 'xl',
}) => {
    const sectionClasses = `
        ${styles.section}
        ${styles[`section--${background}`]}
        ${styles[`section--${padding}`]}
        ${className}
    `.trim();

    const containerClasses = `
        ${styles.container}
        ${styles[`container--${maxWidth}`]}
    `.trim();

    const headerClasses = `
        ${styles.header}
        ${styles[`header--${textAlign}`]}
    `.trim();

    return (
        <section className={sectionClasses}>
            <div className={containerClasses}>
                {(title || subtitle) && (
                    <div className={headerClasses}>
                        {title && <h2 className={styles.title}>{title}</h2>}
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                )}
                <div className={styles.content}>{children}</div>
            </div>
        </section>
    );
};

export default Section;
